module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1186.3fc4f6e4.png";